import { Sparkles, Phone, Mail, MapPin } from "lucide-react";
import { BRAND, SERVICES } from "@/data/content";

export const Footer = () => {
    return (
        <footer
            data-testid="site-footer"
            className="bg-[#0B1B2B] text-white relative overflow-hidden"
        >
            <div className="absolute -top-32 -left-32 w-[440px] h-[440px] rounded-full bg-[#0055FF]/15 blur-3xl pointer-events-none" />
            <div className="onx-container relative py-16 sm:py-20">
                <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
                    {/* Brand */}
                    <div className="md:col-span-5">
                        <div className="flex items-center gap-3">
                            <div className="w-11 h-11 rounded-2xl bg-[#0055FF] flex items-center justify-center">
                                <Sparkles
                                    className="w-5 h-5 text-white"
                                    strokeWidth={2.5}
                                />
                            </div>
                            <div className="flex flex-col leading-none">
                                <span className="font-black text-xl tracking-tight text-white">
                                    {BRAND.name}
                                </span>
                                <span className="text-[10px] font-semibold uppercase tracking-[0.18em] text-white/60">
                                    Profesyonel Temizlik
                                </span>
                            </div>
                        </div>
                        <p className="mt-5 max-w-sm text-sm leading-relaxed text-white/70">
                            ONX Care; Beşiktaş merkezli, tüm İstanbul'a
                            haftanın 7 günü hizmet veren profesyonel temizlik
                            markası.
                        </p>
                        <a
                            href={BRAND.whatsapp}
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid="footer-cta-whatsapp"
                            className="mt-6 onx-btn-primary inline-flex"
                        >
                            Hemen Teklif Al
                        </a>
                    </div>

                    {/* Services list */}
                    <div className="md:col-span-4">
                        <div className="text-[11px] font-bold uppercase tracking-[0.22em] text-white/50 mb-5">
                            Hizmetler
                        </div>
                        <ul className="grid grid-cols-1 gap-2 text-sm">
                            {SERVICES.map((s) => (
                                <li key={s.id}>
                                    <a
                                        href="#hizmetler"
                                        className="text-white/80 hover:text-white transition-colors"
                                    >
                                        {s.title}
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* Contact */}
                    <div className="md:col-span-3">
                        <div className="text-[11px] font-bold uppercase tracking-[0.22em] text-white/50 mb-5">
                            İletişim
                        </div>
                        <ul className="space-y-3 text-sm">
                            <li className="flex items-start gap-2.5 text-white/80">
                                <Phone className="w-4 h-4 mt-0.5 text-[#7AA5FF]" />
                                <a
                                    href={`tel:+${BRAND.phoneRaw}`}
                                    className="hover:text-white"
                                >
                                    {BRAND.phoneDisplay}
                                </a>
                            </li>
                            <li className="flex items-start gap-2.5 text-white/80">
                                <Mail className="w-4 h-4 mt-0.5 text-[#7AA5FF]" />
                                <a
                                    href={`mailto:${BRAND.email}`}
                                    className="hover:text-white break-all"
                                >
                                    {BRAND.email}
                                </a>
                            </li>
                            <li className="flex items-start gap-2.5 text-white/80">
                                <MapPin className="w-4 h-4 mt-0.5 text-[#7AA5FF]" />
                                <span>{BRAND.locationLong}</span>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="mt-14 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-white/50">
                    <div>
                        © {new Date().getFullYear()} {BRAND.name}. Tüm hakları
                        saklıdır.
                    </div>
                    <div>{BRAND.hours}</div>
                </div>
            </div>
        </footer>
    );
};
